(function ($) {

    // Update favourites counter on button click
    $(function () {

        var searchResultsSection = $('#directory-search-results');
        var elements = null;

        if (isSingleProviderPage()) {
            elements = $('.provider-information__call-to-actions');
        } else {
            elements = searchResultsSection.find('.provider-card');
        }

        // No elements?
        if (elements.length === 0) {
            return;
        }

        // AJAX functionality
        elements.each(function () {
            var favouriteBtn = $(this).find('.btn--favourite');
            var providerID = $(favouriteBtn).data('provider-id');

            if (favouriteBtn.length === 0) {
                return;
            }

            favouriteBtn.on('click', function () {
                $.ajax({
                    type: 'GET',
                    url: settings.ajax_url,
                    dataType: 'json',
                    data: {
                        action: 'directory_favourites',
                        provider_id: providerID,
                    },
                    context: this,
                    success: function (response) {
                        if (response.success !== true) {
                            return;
                        }

                        // Do stuff on success
                        // Toggle button active state class
                        $(this).toggleClass('btn--favourite-active');

                        // Display tooltip
                        if (!$(this).hasClass('btn--favourite-active')) {
                            addTooltip($(this), 'removed');

                            // Update button text
                            this.firstChild.textContent = 'Add to contact list';

                            // Update counter
                            updateFavouritesCounter();
                        } else {
                            addTooltip($(this), 'added');

                            // Update button text
                            this.firstChild.textContent = 'Remove from contact list';

                            // Update counter
                            updateFavouritesCounter();
                        }

                        // Remove item from favourites list page
                        if (isDirectoryFavouritesListPage()) {
                            if (!$(this).hasClass('btn--favourite-active')) {
                                $(this).parents('.service').remove();
                            }
                            removeFavouritesForm();
                            removeFavouritesButtonRow();
                        }
                    },
                });
            });
        });
    });

    // Update favourites counter on every page load
    $(function () {
        updateFavouritesCounter();
    });

    /** --------------------------------- FUNCTIONS ---------------------------------------- */

    /**
     * Check if a link that allows users to access directory favourites exists.
     * 
     * @returns {boolean}
     * @deprecated
     */
    function favouritesAccessLinkExists() {
        var accessLink = $('#favourites-access-link');

        if (accessLink.length === 1) {
            return true;
        } else if (accessLink.length === 0) {
            return false;
        }
    }

    /**
     * Check if the directory favourites page is in view.
     * 
     * @returns {boolean}
     */
    function isDirectoryFavouritesListPage() {
        var listWrapper = $('#directory-favourites-list');

        if (listWrapper.length < 1) {
            return false;
        }

        return true;
    }

    /**
     * Check if the current page is the single provider page.
     * 
     * @returns {boolean}
     */
    function isSingleProviderPage() {
        var element = $('.provider-information');

        if (element.length === 0) {
            return false;
        }

        return true;
    }

    /**
     * Remove form that allows users to send favourites to email.
     * 
     * @returns {void}
     */
    function removeFavouritesForm() {
        var favourites = $('#directory-favourites-list .service');
        var count = favourites.length;
        var form = $('.main-form--directory-favourites-form');

        if (count === 0) {
            form.parents('.main-form').remove();
        }
    }

    /**
     * Remove the favourites PDF download button.
     * 
     * @returns {void}
     */
    function removeFavouritesButtonRow() {
        var row = $('.favourites-button-row');
        var favourites = $('#directory-favourites-list .service');
        var favCount = favourites.length;

        if (row.length && favCount === 0) {
            row.remove();
        }
    }

    /**
     * Add a tooltip CSS class to an element.
     * The CSS class is removed after 1000ms.
     * 
     * @param {string} element 
     * @param {string} className 
     * @returns {void}
     */
    function addTooltip(element, className) {
        element.addClass(className);

        setTimeout(function () {
            element.removeClass(className);
        }, 1000);
    }

    /**
     * Update the favourite providers counter.
     * 
     * @param {*} action 
     * @returns {void}
     */
    function updateFavouritesCounter(action = null) {
        var counter = $('#favourites-access-link .btn-counter');

        if (counter.length < 1) {
            return;
        }

        // Step 1: Get the cookie
        cookieValue = document.cookie.split('; ').find(row => row.startsWith('directory_favourites_encode'));

        if (cookieValue === undefined) {
            return;
        }

        cookieValue = cookieValue.split('=');

        var decodedValue = decodeURIComponent(cookieValue[1]);

        cookieValue = JSON.parse(decodedValue);

        // Step 3: Get the count of array elements
        const count = cookieValue ? Object.keys(cookieValue).length : 0;

        // Apply new count value to element
        counter.text(count);
    }
})(jQuery);